export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIME_OUT = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = "a3dc3418-de25-416b-b460-0967de336098";
export const MODAL_CLOSE_SEC = 2.5;
